import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsSidenavComponent } from './settings-sidenav.component';
import { MaterialModule } from 'src/app/material.module';
import { FunctiiModule } from './functii/functii.module';
import { UserSettingsModule } from './users-settings/user-settings.module';
import { DirectiiModule } from './directii/directii.module';
import { DepartmentsSettingsModule } from './departments-settings/departments-settings.module';
import { ConfigSettingsModule } from './config-settings/config-settings.module';
import { PlatformSectionModule } from './platform-section/platform-section.module';
import { PlatformFaqModule } from './platform-faq/platform-faq.module';
import { PlatformContentModule } from './platform-content/platform-content.module';
import { PlatformAnnouncesModule } from './platform-anunturi/platform-announces.module';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CompartimenteModule } from './compartimente/compartimente.module';
import { JudeteModule } from './judete/judete.module';
import { CerereTypeModule } from './cerere-type/cerere-type.module';
import { CerereStatusModule } from './cerere-status/cerere-status.module';
import { CererePriorityModule } from './cerere-priority/cerere-priority.module';
import { CerereSabloaneModule } from './cerere-sabloane/cerere-sabloane.module';
import { TipuriDocumenteModule } from './tipuri-documente/tipuri-documente.module';
import { TariModule } from "./tari/tari.module";
import { LocalitatiModule } from './localitati/localitati.module';
import { StraziModule } from './strazi/strazi.module';

@NgModule({
    declarations: [
        SettingsSidenavComponent,
    ],
    imports: [
        CommonModule,
        CompartimenteModule,
        CerereTypeModule,
        CerereStatusModule,
        CererePriorityModule,
        JudeteModule,
        MaterialModule,
        FunctiiModule,
        UserSettingsModule,
        DirectiiModule,
        DepartmentsSettingsModule,
        ConfigSettingsModule,
        PlatformSectionModule,
        PlatformFaqModule,
        PlatformContentModule,
        PlatformAnnouncesModule,
        FormsModule,
        ReactiveFormsModule,
        CerereSabloaneModule,
        TipuriDocumenteModule,
        TariModule,
        LocalitatiModule,
        StraziModule,
    ],
    exports: [SettingsSidenavComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsSidenavModule { }
